import {
  handleDefaultReadingLevelChange,
  setAssignmentMember,
} from "@/assignments/utils/assignmentActions";
import SelectedStateIndicator from "@/components/SelectedStateIndicator";
import { NUMERICAL_GRADE_BANDS } from "@/constants/GradeAndLexileLevels";
import { LANG_TOGGLE_LIST } from "@/constants/Language";
import { Assignment } from "@/types/models/Assignment.interface";
import ContentLevel from "@/types/models/ContentLevel.interface";
import { EventProperties } from "@/types/models/EventProperties.interface";
import ActionsDropdown from "@/view/ActionsDropdown";
import filterLevelsByLanguage from "@/view/utils/filterLevelsByLanguage";
import getBestLanguageMatch from "@/view/utils/getBestLanguageMatch";
import getLanguageText from "@/view/utils/getLanguageText";
import updateLevelIdAndResetActivityQueryParams from "@/view/utils/updateLevelIdAndResetActivityQueryParams";
import { TCurrentLevel } from "@/view/utils/useUpdateLevel/useUpdateLevel";
interface RenderLanguages {
  closeDropdown: () => () => boolean;
  currentLevel: ContentLevel;
  dispatch: () => void;
  eventProperties: EventProperties;
  setCurrentLevel: (level: TCurrentLevel) => void;
  sortedLevels: ContentLevel[];
  updatedAssignment: Assignment;
}

export const renderLanguages = ({
  closeDropdown,
  currentLevel,
  dispatch,
  eventProperties,
  setCurrentLevel,
  sortedLevels,
  updatedAssignment,
}: RenderLanguages) => {
  const assignmentMemberContentId =
    updatedAssignment.assignment_members?.[0]?.content_id;
  const hasLanguageChanged =
    !!assignmentMemberContentId &&
    assignmentMemberContentId !== currentLevel?.header_id;

  return LANG_TOGGLE_LIST.map((lang) => {
    const isSelected = lang === currentLevel?.language;
    const onClick = () => {
      const filteredByLanguageList = filterLevelsByLanguage(sortedLevels, lang);
      const bestLevelMatch: ContentLevel = getBestLanguageMatch(
        filteredByLanguageList,
        currentLevel,
      ) as ContentLevel;

      setCurrentLevel(bestLevelMatch);

      if (bestLevelMatch) {
        void updateLevelIdAndResetActivityQueryParams(bestLevelMatch?.id).catch(
          console.error,
        );
      }
      if (hasLanguageChanged && updatedAssignment?.default_reading_level) {
        const currentReadingLevel =
          NUMERICAL_GRADE_BANDS[currentLevel?.grade_band];
        handleDefaultReadingLevelChange(currentReadingLevel, dispatch);
      }
      // The assignment member should reflect the language of the content.
      setAssignmentMember(bestLevelMatch?.header_id, dispatch);
      closeDropdown();
    };

    const dropdownEventProperties = {
      ...eventProperties,
      description: `Change article language to ${getLanguageText(lang) || ""}.`,
    };

    return (
      <ActionsDropdown.ButtonItem
        dataProps={{ "data-qa-selector": `language option: ${lang}` }}
        onClick={onClick}
        key={lang}
        eventProperties={dropdownEventProperties}
      >
        <SelectedStateIndicator shouldDisplay={isSelected} />
        {getLanguageText(lang)}
      </ActionsDropdown.ButtonItem>
    );
  });
};

export default renderLanguages;
